import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { TableCell } from "@react/ui-primitives/table";

import { useTablesActions } from "../hooks/useTablesActions.ts";

import { TableSyncStatus } from "./TableSyncStatus.tsx";

interface TableItemProps {
  readonly tableName: string;
}

export const TableItem: FC<TableItemProps> = ({ tableName }) => {
  const { syncTable } = useTablesActions();

  return (
    <>
      <TableCell>{tableName}</TableCell>
      <TableCell>
        <div className="flex items-center justify-end">
          <TableSyncStatus
            isSending={syncTable.isPending}
            onSync={bindArgs(syncTable.mutate, { tableName })}
            tableName={tableName}
          />
        </div>
      </TableCell>
    </>
  );
};
